import { EditorInput } from '../EditorInput';
import { customizeCraftJsComponent } from '../../helpers';
import { emailPattern } from '../inputValidationPatterns';
import { EditorLoginIdInputSettings } from '../EditorLoginIdInputSettings';

export const EditorEmailInput = customizeCraftJsComponent(EditorInput, {
	name: 'Email Input',
	props: {
		name: 'email',
		type: 'email',
		placeholder: 'Email',
		label: 'Email',
		pattern: emailPattern,
		'data-errormessage-pattern-mismatch': 'Must be a valid email',
		autoComplete: null as any // we cannot use undefined because we getting the uncontrolled to controlled warning, and empty string is adding the attribute to the dom
	},
	related: {
		settings: EditorLoginIdInputSettings
	}
});
